<template>
  <div class="productCard">
    <div class="title">已提交信息</div>
    <div class="reportOrder">
      <div class="key">举报订单</div>
      <div class="value">{{historyInfo.orderId}}</div>
    </div>
    <div class="reportType">
      <div class="key">举报类型</div>
      <div class="value">{{historyInfo.reportType}}</div>
    </div>
    <div class="desc">
      <div class="key">举报描述</div>
      <div class="value">{{historyInfo.reportEvidence}}</div>
    </div>
    <div v-if="historyInfo.supplementEvidence" class="desc">
      <div class="key">补充描述</div>
      <div class="value">{{historyInfo.supplementEvidence}}</div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ReportInfo',
  data() {
    return {
    }
  },
  props: {
    historyInfo: {
      default: function () {
        return {}
      }
    }
  }
}
</script>

<style scoped lang="less">
@import 'index.less';
</style>
